"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("react");
var react_2 = require("@emotion/react");
var icons_1 = require("../../icons");
var constant_1 = require("../../constant");
var styles_1 = require("./styles");
var BreadcrumbSeparator = function (props) {
    var theme = react_2.useTheme();
    var defaultSeparator = '/';
    if (theme.name === constant_1.DESIGN_SYSTEM) {
        defaultSeparator = react_2.jsx(icons_1.SlashDivider, { size: 20 });
    }
    var children = props.children || defaultSeparator;
    var styles = react_1.useMemo(function () { return styles_1.getBreadcrumbSeparatorStyleConfig(theme); }, [theme]);
    return (react_2.jsx("span", { css: styles.container }, children));
};
exports.default = BreadcrumbSeparator;
